import React from 'react'
import '../privacyTabs/PrivacyTab.css'

const PrivacyTab = () => {
  return (
    <div className="tabs-detail-sec setting-tab">
      PrivacyTab
    </div>
  )
}

export default PrivacyTab
